var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState, } from "react";
import { useSelector } from "react-redux";
import { cloneDeep } from "lodash";
// icons
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import somethingWentWrong from "@frameworks/shared-library/assets/images/markets/somethingWentWrong.svg";
//stylesheet
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/Alert/alert.scss";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsTable.scss";
import "@frameworks/salesjourney/stylesheets/components/Features/ClientDetails/ClientOverview/clientOwner.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
// components
import TopFundsTableDesk from "./TopFundsTableDesk";
import SummarySortFilters from "../../../components/TableComponent/SummarySortFilters";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import SummaryFilters from "../../../components/TableComponent/SummaryFilters";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import SearchPanelWithPopupFiltersLabel from "../../../components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
// helpers
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { pmsTabs } from "../../../constants";
import { FilterSortListBookMark, FieldNames, } from "../../../constants/constant";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
var TableComponent = function (_a) {
    //
    var setOpenSB = _a.setOpenSB, setRowOpenSb = _a.setRowOpenSb, requestPayload = _a.requestPayload, setRequestPayload = _a.setRequestPayload, totalPages = _a.totalPages, aifPmsListData = _a.aifPmsListData, subCategoryId = _a.subCategoryId, aifPmsLoader = _a.aifPmsLoader, header = _a.header, totalRecord = _a.totalRecord, error = _a.error, setWatchlistData = _a.setWatchlistData, rowOnClick = _a.rowOnClick, onClickPlaceOrder = _a.onClickPlaceOrder, viewAll = _a.viewAll, viewAllClick = _a.viewAllClick, showDataPerPage = _a.showDataPerPage, viewAllClickPath = _a.viewAllClickPath, handleCallbackSearchFunds = _a.handleCallbackSearchFunds, isAll = _a.isAll, setTotalDataRecord = _a.setTotalDataRecord, fundTotalPages = _a.fundTotalPages, setFundTotalPages = _a.setFundTotalPages;
    var device = DeviceContext();
    var _b = __read(useState(false), 2), isShowFilterPopup = _b[0], setIsShowFilterPopup = _b[1];
    var _c = __read(useState(pmsTabs[0].eventKey), 2), tab = _c[0], setTab = _c[1];
    var _d = __read(useState([]), 2), filterLabels = _d[0], setFilterLabels = _d[1];
    var _e = __read(useState(false), 2), isClear = _e[0], setIsClear = _e[1];
    var _f = __read(useState(false), 2), isAumSize = _f[0], setIsAumSize = _f[1];
    var _g = __read(useState({}), 2), selectedValue = _g[0], setSelectedValue = _g[1];
    var _h = useSelector(function (state) { return state.markets.AifPms; }), filterDetailsAmc = _h.filterDetailsAmc, filterDetailsFund = _h.filterDetailsFund, filterDetailsCategory = _h.filterDetailsCategory, filterListFundName = _h.filterListFundName, filterListAIFFundName = _h.filterListAIFFundName;
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    var _j = __read(useState({
        conditionType: {
            conditionType: { label: "Above", value: "Above" },
            conditionValue: "",
        },
        returnExpectation: {
            returnExpectation: { label: "Above", value: "Above" },
            conditionValue: "",
        },
        drawdown: {
            drawdown: { label: "Above", value: "Above" },
            conditionValue: "",
        },
        amcNameList: [],
        fundManagerList: [],
        fundNameList: [],
    }), 2), summaryData = _j[0], setSummaryData = _j[1];
    var handleUpdateFilterPopupState = function (state) {
        if (state) {
            fetchFundManager();
        }
        setIsShowFilterPopup(state);
    };
    var fetchFundManager = useCallback(function () {
        aifPmsDi.aifPms.getFilterDetails({
            category_code: String(subCategoryId),
            fieldName: FieldNames.FUNDMANAGER,
        });
    }, []);
    var _k = __read(useState(false), 2), showToast = _k[0], setShowToast = _k[1];
    var _l = __read(useState({
        isError: false,
        msg: "",
    }), 2), toastDetails = _l[0], setToastDetails = _l[1];
    var _m = __read(useState({}), 2), filters = _m[0], setFilters = _m[1];
    useEffect(function () {
        setSelectedValue({
            name: "Return exp. - High to Low",
            value: "returns_expectations-desc",
            type: true,
            filterValue: "returns_expectations",
        });
    }, []);
    var removebookMark = function (schemeCode) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, aifPmsDi.aifPms.bookmark({
                            schemeId: schemeCode.join(","),
                            categoryCode: String(subCategoryId),
                            actionType: "DELETE",
                        })];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === "SUCCESS") {
                        setShowToast(true);
                        setRequestPayload({
                            page: 1,
                            pageSize: 5,
                            category_code: subCategoryId,
                            LoginCode: profileData.empcodetxt,
                            isFocused: tab == "1" ? true : false,
                            orderBy: "returns_expectations",
                            orderByDesc: true,
                        });
                        setToastDetails({
                            isError: true,
                            msg: "Bookmark removed successfully!",
                        });
                        setWatchlistData(function (prev) {
                            return prev.filter(function (element) { return element.schemeId !== Number(schemeCode); });
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setShowToast(true);
                    setToastDetails({
                        isError: true,
                        msg: "Failed to Remove Bookmark!",
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var removeEmptyObjects = function (obj) {
        if (Array.isArray(obj)) {
            return obj.length === 0 ? undefined : obj.map(removeEmptyObjects);
        }
        if (obj && typeof obj === "object") {
            var cleanedObj = {};
            for (var key in obj) {
                var cleanedValue = removeEmptyObjects(obj[key]);
                if (cleanedValue !== undefined && cleanedValue !== null) {
                    cleanedObj[key] = cleanedValue;
                }
            }
            return Object.keys(cleanedObj).length === 0 ? undefined : cleanedObj;
        }
        return obj;
    };
    var handleSortApplyFilters = function () {
        if (selectedValue) {
            setRequestPayload(__assign(__assign({}, requestPayload), { orderByDesc: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.type, orderBy: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.filterValue, page: 1 }));
        }
        else {
            setRequestPayload(__assign(__assign({}, requestPayload), { orderByDesc: true, orderBy: "returns_expectations", page: 1 }));
        }
        setIsShowFilterPopup(false);
    };
    var handleApplyFilters = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        var newRequestPayload = cloneDeep(requestPayload);
        newRequestPayload = __assign(__assign({}, newRequestPayload), { aumSize: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.aumSize) || {}, returns_expectations: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.returns_expectations) || {}, drawdown: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.drawdown) || {}, fundManagerList: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.fundManagerList) || "", amcNameList: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.amcNameList) || "", categoryNameList: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.categoryNameList) || "", fundNameList: newRequestPayload.fundNameList, page: 1 });
        if ((_a = data === null || data === void 0 ? void 0 : data.conditionType) === null || _a === void 0 ? void 0 : _a.conditionValue) {
            newRequestPayload.aumSize = {
                conditionType: ((_d = (_c = (_b = data.conditionType) === null || _b === void 0 ? void 0 : _b.conditionType) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.toUpperCase()) || "",
                conditionValue: ((_e = data.conditionType) === null || _e === void 0 ? void 0 : _e.conditionValue) || "",
            };
        }
        else {
            delete newRequestPayload.aumSize;
        }
        if (data === null || data === void 0 ? void 0 : data.inceptionDate) {
            newRequestPayload.inceptionDate = data.inceptionDate;
        }
        else {
            delete newRequestPayload.inceptionDate;
        }
        if ((_f = data === null || data === void 0 ? void 0 : data.returnExpectation) === null || _f === void 0 ? void 0 : _f.conditionValue) {
            newRequestPayload.returns_expectations = {
                conditionType: ((_j = (_h = (_g = data.returnExpectation) === null || _g === void 0 ? void 0 : _g.returnExpectation) === null || _h === void 0 ? void 0 : _h.value) === null || _j === void 0 ? void 0 : _j.toUpperCase()) || "",
                conditionValue: ((_k = data.returnExpectation) === null || _k === void 0 ? void 0 : _k.conditionValue) || "",
            };
        }
        else {
            delete newRequestPayload.returns_expectations;
        }
        // Add condition for Drawdown if available
        if ((_l = data === null || data === void 0 ? void 0 : data.drawdown) === null || _l === void 0 ? void 0 : _l.conditionValue) {
            newRequestPayload.drawdown = {
                conditionType: ((_p = (_o = (_m = data.drawdown) === null || _m === void 0 ? void 0 : _m.drawdown) === null || _o === void 0 ? void 0 : _o.value) === null || _p === void 0 ? void 0 : _p.toUpperCase()) || "",
                conditionValue: ((_q = data.drawdown) === null || _q === void 0 ? void 0 : _q.conditionValue) || "",
            };
        }
        else {
            delete newRequestPayload.drawdown;
        }
        // Handle fund manager list
        if (((_r = data === null || data === void 0 ? void 0 : data.fundManagerList) === null || _r === void 0 ? void 0 : _r.length) > 0) {
            newRequestPayload.fundManagerList = data.fundManagerList.join("## ");
        }
        else {
            delete newRequestPayload.fundManagerList;
        }
        // Handle AMC name list
        if (((_s = data === null || data === void 0 ? void 0 : data.amcNameList) === null || _s === void 0 ? void 0 : _s.length) > 0) {
            var filterWithoutAll = data.amcNameList.filter(function (item) { return item !== "all"; });
            newRequestPayload.amcNameList = filterWithoutAll.join(", ");
        }
        else {
            delete newRequestPayload.amcNameList;
        }
        if (((_t = data === null || data === void 0 ? void 0 : data.fundNameList) === null || _t === void 0 ? void 0 : _t.length) > 0) {
            var filterWithoutAll = data.fundNameList.filter(function (item) { return item !== "all"; });
            newRequestPayload.fundNameList = filterWithoutAll.join(", ");
        }
        else {
            delete newRequestPayload.fundNameList;
        }
        if (((_u = data === null || data === void 0 ? void 0 : data.tenureList) === null || _u === void 0 ? void 0 : _u.length) > 0) {
            var filterWithoutAll = data.tenureList.filter(function (item) { return item !== "all"; });
            newRequestPayload.tenureList = filterWithoutAll.join(", ");
        }
        else {
            delete newRequestPayload.tenureList;
        }
        if (((_v = data === null || data === void 0 ? void 0 : data.benchmarkList) === null || _v === void 0 ? void 0 : _v.length) > 0) {
            var filterWithoutAll = data.benchmarkList.filter(function (item) { return item !== "all"; });
            newRequestPayload.benchmarkList = filterWithoutAll.join(", ");
        }
        else {
            delete newRequestPayload.benchmarkList;
        }
        if (((_w = data === null || data === void 0 ? void 0 : data.categoryNameList) === null || _w === void 0 ? void 0 : _w.length) > 0) {
            var filterWithoutAll = data.categoryNameList.filter(function (item) { return item !== "all"; });
            newRequestPayload.categoryNameList = filterWithoutAll.join(", ");
        }
        else {
            delete newRequestPayload.categoryNameList;
        }
        newRequestPayload = removeEmptyObjects(newRequestPayload);
        setRequestPayload(newRequestPayload);
        setIsShowFilterPopup(false);
        var filterLabel = [];
        if (((_x = newRequestPayload.aumSize) === null || _x === void 0 ? void 0 : _x.conditionType) &&
            ((_y = newRequestPayload.aumSize) === null || _y === void 0 ? void 0 : _y.conditionValue)) {
            var aumLabel = "".concat(newRequestPayload.aumSize.conditionType).concat(newRequestPayload.aumSize.conditionValue);
            filterLabel.push({
                title: aumLabel,
                value: aumLabel,
                typeOfFilter: "aumSize",
            });
        }
        if (((_z = newRequestPayload.returns_expectations) === null || _z === void 0 ? void 0 : _z.conditionType) &&
            ((_0 = newRequestPayload.returns_expectations) === null || _0 === void 0 ? void 0 : _0.conditionValue)) {
            var returnExpLabel = "".concat(newRequestPayload.returns_expectations.conditionType).concat(newRequestPayload.returns_expectations.conditionValue);
            filterLabel.push({
                title: returnExpLabel,
                value: returnExpLabel,
                typeOfFilter: "returns_expectations",
            });
        }
        if (((_1 = newRequestPayload.drawdown) === null || _1 === void 0 ? void 0 : _1.conditionType) &&
            ((_2 = newRequestPayload.drawdown) === null || _2 === void 0 ? void 0 : _2.conditionValue)) {
            var drawdownLabel = "".concat(newRequestPayload.drawdown.conditionType).concat(newRequestPayload.drawdown.conditionValue);
            filterLabel.push({
                title: drawdownLabel,
                value: drawdownLabel,
                typeOfFilter: "drawdown",
            });
        }
        var combinedLabelsfundManagerList = [];
        if (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.fundManagerList) {
            combinedLabelsfundManagerList = data === null || data === void 0 ? void 0 : data.fundManagerList.map(function (item) { return ({
                title: item,
                value: item,
                typeOfFilter: "fundManagerList",
            }); });
        }
        var updatedArrayFund = combinedLabelsfundManagerList.map(function (item) {
            var match = filterDetailsFund.find(function (secItem) { return secItem.Name === item.value; });
            if (match) {
                return __assign(__assign({}, item), { title: match.filterId });
            }
            return item;
        });
        var combinedLabelsamcNameList = [];
        if (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.amcNameList) {
            combinedLabelsamcNameList = data === null || data === void 0 ? void 0 : data.amcNameList.map(function (item) { return ({
                title: item,
                value: item,
                typeOfFilter: "amcNameList",
            }); });
        }
        var updatedArray = combinedLabelsamcNameList.map(function (item) {
            var match = filterDetailsAmc.find(function (secItem) { return secItem.name === item.value; });
            if (match) {
                return __assign(__assign({}, item), { title: match.filterId });
            }
            return item;
        });
        var combinedLabelsFundNameList = [];
        if (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.fundNameList) {
            combinedLabelsFundNameList = data === null || data === void 0 ? void 0 : data.fundNameList.map(function (item) { return ({
                title: item,
                value: item,
                typeOfFilter: "fundNameList",
            }); });
        }
        var updatedArrayFundName = combinedLabelsFundNameList.map(function (item) {
            var fundData = String(subCategoryId) === ESubProductIds.AIF
                ? filterListAIFFundName
                : filterListFundName;
            var match = fundData.find(function (secItem) { return secItem.name === item.value; });
            if (match) {
                return __assign(__assign({}, item), { title: match.filterId });
            }
            return item;
        });
        var combinedLabelscategoryNameList = [];
        if (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.categoryNameList) {
            combinedLabelscategoryNameList = data === null || data === void 0 ? void 0 : data.categoryNameList.map(function (item) { return ({
                title: item,
                value: item,
                typeOfFilter: "categoryNameList",
            }); });
        }
        var updatedArrayCategory = combinedLabelscategoryNameList.map(function (item) {
            var match = filterDetailsCategory.find(function (secItem) { return secItem.filterId === item.title; });
            if (match) {
                return __assign(__assign({}, item), { title: match.name });
            }
            return item;
        });
        var fundData = updatedArrayFundName.filter(function (item) {
            return (item === null || item === void 0 ? void 0 : item.title) !== "All";
        });
        setFilterLabels(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(filterLabel), false), __read(updatedArrayFund), false), __read(updatedArray), false), __read(updatedArrayCategory), false), __read(fundData), false));
    };
    var handleClearAllFilters = function () {
        setRequestPayload({
            page: 1,
            pageSize: 10,
            category_code: subCategoryId,
            LoginCode: profileData.empcodetxt,
            isFocused: tab == "1" ? true : false,
            orderBy: "returns_expectations",
            orderByDesc: true,
        });
        setIsShowFilterPopup(false);
        setSelectedValue({});
        setFilterLabels([]);
        setIsClear(true);
        setSummaryData({
            conditionType: {
                conditionType: { label: "Above", value: "Above" },
                conditionValue: "",
            },
            returnExpectation: {
                returnExpectation: { label: "Above", value: "Above" },
                conditionValue: "",
            },
            drawdown: {
                drawdown: { label: "Above", value: "Above" },
                conditionValue: "",
            },
            amcNameList: [],
            fundManagerList: [],
            fundNameList: [],
        });
        aifPmsDi.aifPms.getFilterDetails({
            category_code: String(subCategoryId),
            fieldName: FieldNames.FUNDMANAGER,
        });
        localStorage.removeItem("fundManagerSearchText");
    };
    var handleRadioChange = function (e, item) {
        setSelectedValue(item);
    };
    var handleRemoveThroughLabels = function (typeOfFilter, value) {
        var _a, _b, _c, _d, _e, _f, _g;
        setIsAumSize(false);
        var updatedRequestPayload = __assign(__assign({}, requestPayload), { orderByDesc: true, orderBy: "returns_expectations" });
        var filterAndUpdate = function (filterLabels, updatedRequestPayload, typeOfFilter, value) {
            var filteredLabels = filterLabels.filter(function (item) {
                if (typeOfFilter === "amcNameList" ||
                    typeOfFilter === "fundManagerList" ||
                    typeOfFilter === "categoryNameList" ||
                    typeOfFilter === "fundNameList") {
                    return value.length > 0
                        ? !value.includes(item.value)
                        : item.value !== value;
                }
                else {
                    delete updatedRequestPayload[typeOfFilter];
                    return item.typeOfFilter !== typeOfFilter;
                }
            });
            return { filteredLabels: filteredLabels };
        };
        var result = filterAndUpdate(filterLabels, updatedRequestPayload, typeOfFilter, value);
        var filteredDataAmcNameList = result === null || result === void 0 ? void 0 : result.filteredLabels.map(function (item) {
            return item.typeOfFilter === "amcNameList" ? item.value : null;
        });
        var filteredDataFundManList = result === null || result === void 0 ? void 0 : result.filteredLabels.map(function (item) {
            return item.typeOfFilter === "fundManagerList" ? item.value : null;
        });
        var filteredDataCategoryList = result === null || result === void 0 ? void 0 : result.filteredLabels.map(function (item) {
            return item.typeOfFilter === "categoryNameList" ? item.value : null;
        });
        var filteredDatafundNmaeList = result === null || result === void 0 ? void 0 : result.filteredLabels.map(function (item) {
            return item.typeOfFilter === "fundNameList" ? item.value : null;
        });
        if (typeOfFilter === "fundNameList") {
            var data_1 = result === null || result === void 0 ? void 0 : result.filteredLabels.filter(function (item) { return item.title !== "all"; });
            var filter = void 0;
            var fundData = String(subCategoryId) === ESubProductIds.AIF
                ? filterListAIFFundName
                : filterListFundName;
            if (data_1.length < fundData.length) {
                filter = filteredDatafundNmaeList.filter(function (item) { return item !== null && item !== "all"; });
            }
            else {
                filter = filteredDatafundNmaeList.filter(function (item) {
                    return item !== null && item !== "all";
                });
            }
            if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
                updatedRequestPayload["fundNameList"] = filter.join(", ");
            }
            else {
                delete updatedRequestPayload["fundNameList"];
            }
        }
        if (typeOfFilter === "amcNameList") {
            var data_2 = result === null || result === void 0 ? void 0 : result.filteredLabels.filter(function (item) { return item.title !== "all"; });
            var filter = void 0;
            if (data_2.length < filterDetailsAmc.length) {
                filter = filteredDataAmcNameList.filter(function (item) { return item !== null && item !== "all"; });
            }
            else {
                filter = filteredDataAmcNameList.filter(function (item) {
                    return item !== null && item !== "all";
                });
            }
            if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
                updatedRequestPayload["amcNameList"] = filter.join(", ");
            }
            else {
                delete updatedRequestPayload["amcNameList"];
            }
        }
        if (typeOfFilter === "categoryNameList") {
            var data_3 = result === null || result === void 0 ? void 0 : result.filteredLabels.filter(function (item) { return item.title !== "all"; });
            var filter = void 0;
            if (data_3.length < filterDetailsCategory.length) {
                filter = filteredDataCategoryList.filter(function (item) { return item !== null && item !== "all"; });
            }
            else {
                filter = filteredDataCategoryList.filter(function (item) {
                    return item !== null && item !== "all";
                });
            }
            if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
                updatedRequestPayload["categoryNameList"] = filter.join(", ");
            }
            else {
                delete updatedRequestPayload["categoryNameList"];
            }
        }
        if (typeOfFilter === "fundManagerList") {
            var filter = filteredDataFundManList.filter(function (item) {
                return item !== null;
            });
            if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
                updatedRequestPayload["fundManagerList"] = filter.join("## ");
            }
            else {
                delete updatedRequestPayload["fundManagerList"];
            }
        }
        // setRequestPayload(updatedRequestPayload);
        setFilterLabels(result === null || result === void 0 ? void 0 : result.filteredLabels);
        var amcList = (_a = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.amcNameList) === null || _a === void 0 ? void 0 : _a.split(", ").map(String);
        var categoryNameList = (_b = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.categoryNameList) === null || _b === void 0 ? void 0 : _b.split(", ").map(String);
        var fundManagerList = (_c = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.fundManagerList) === null || _c === void 0 ? void 0 : _c.split("## ").map(String);
        var fundNameList = (_d = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.fundNameList) === null || _d === void 0 ? void 0 : _d.split(", ").map(String);
        var conditionData = function (field, defaultValue, fieldSec) {
            var _a;
            var _b, _c;
            if (defaultValue === void 0) { defaultValue = ""; }
            return (_a = {},
                _a[fieldSec] = ((_b = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload[field]) === null || _b === void 0 ? void 0 : _b.conditionType) === "ABOVE"
                    ? { label: "Above", value: "Above" }
                    : { label: "Below", value: "Below" },
                _a.conditionValue = ((_c = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload[field]) === null || _c === void 0 ? void 0 : _c.conditionValue) || defaultValue,
                _a);
        };
        setIsAumSize(true);
        var data = __assign(__assign({}, summaryData), { amcNameList: amcList ? amcList : [], categoryNameList: categoryNameList ? categoryNameList : [], fundManagerList: fundManagerList ? fundManagerList : [], fundNameList: fundNameList ? fundNameList : [], drawdown: ((_e = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.drawdown) === null || _e === void 0 ? void 0 : _e.conditionValue)
                ? conditionData("drawdown", "", "drawdown")
                : {
                    drawdown: { label: "Above", value: "Above" },
                    conditionValue: "",
                }, returnExpectation: ((_f = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.returns_expectations) === null || _f === void 0 ? void 0 : _f.conditionValue)
                ? conditionData("returns_expectations", "", "returnExpectation")
                : {
                    returnExpectation: { label: "Above", value: "Above" },
                    conditionValue: "",
                }, conditionType: ((_g = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.aumSize) === null || _g === void 0 ? void 0 : _g.conditionValue)
                ? conditionData("aumSize", "", "conditionType")
                : {
                    conditionType: { label: "Above", value: "Above" },
                    conditionValue: "",
                } });
        var cleanUpdatedRequestPayload = function (field, dataKey) {
            var _a;
            if (!((_a = data[dataKey]) === null || _a === void 0 ? void 0 : _a.conditionValue)) {
                delete updatedRequestPayload[field];
            }
        };
        cleanUpdatedRequestPayload("drawdown", "drawdown");
        cleanUpdatedRequestPayload("return_Expectations", "returnExpectation");
        cleanUpdatedRequestPayload("aumSize", "conditionType");
        setSummaryData(data);
        setRequestPayload(updatedRequestPayload);
    };
    var TabContent = useMemo(function () {
        return (React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "mb-20 filters-section-ap", searchBarParentClassName: "w-400", searchValue: requestPayload.searchText, clearSearching: function () {
                return setRequestPayload(__assign(__assign({}, requestPayload), { searchText: "", page: 1 }));
            }, applySearchedFilters: handleCallbackSearchFunds, isShowPopup: isShowFilterPopup, setIsShowPopup: handleUpdateFilterPopupState, placeholder: "Search by name, category and more", handleClearAllPmsFilters: handleClearAllFilters, filterComponentInsidePopup: React.createElement(SummaryFilters, { filtersData: filters, handleFilterChangeCallback: function (updatedFilters) {
                    setFilters(updatedFilters);
                }, handleApplyCallback: handleApplyFilters, handleCancelCallback: function () {
                    if ((filterLabels === null || filterLabels === void 0 ? void 0 : filterLabels.length) == 0) {
                        setIsClear(true);
                    }
                    setIsShowFilterPopup(false);
                }, handleClearAllCallback: handleClearAllFilters, allFiltersLoader: false, setSummaryData: setSummaryData, summaryData: summaryData, isShowFilterPopup: isShowFilterPopup, isClear: isClear, isAumSize: isAumSize, filterLabels: filterLabels, setIsAumSize: setIsAumSize, setIsClear: setIsClear, requestPayload: subCategoryId }), sortFilterComponentInsidePopup: React.createElement(React.Fragment, null,
                React.createElement(SummarySortFilters, { handleRadioChange: handleRadioChange, selectedValue: selectedValue, cancelBtnCallback: function () { return setIsShowFilterPopup(false); }, applyBtnCallback: handleSortApplyFilters, filterSortList: FilterSortListBookMark })), filterLabels: filterLabels, removeFilterThroughLabels: function (typeOfFilter, value) {
                handleRemoveThroughLabels(typeOfFilter, value);
            }, isFilterHeader: true, delay: 800, genericPopup: "aif-pms-bookmark-popup" }));
    }, [
        isShowFilterPopup,
        filterLabels,
        requestPayload,
        setRequestPayload,
        summaryData,
        selectedValue,
    ]);
    var onNextPage = useCallback(function () {
        setRequestPayload(function (prevPayload) {
            if (totalPages > prevPayload.page) {
                return __assign(__assign({}, prevPayload), { page: prevPayload.page + 1 });
            }
            return prevPayload;
        });
    }, [setRequestPayload, totalPages]);
    var setTabValue = function (key) {
        setTab(key);
        setRequestPayload({
            page: 1,
            pageSize: 10,
            category_code: subCategoryId,
            LoginCode: profileData.empcodetxt,
            isFocused: tab == "1" ? false : true,
            orderBy: "returns_expectations",
            orderByDesc: true,
        });
        setFilterLabels([]);
        setSummaryData({
            conditionType: {
                conditionType: { label: "Above", value: "Above" },
                conditionValue: "",
            },
            returnExpectation: {
                returnExpectation: { label: "Above", value: "Above" },
                conditionValue: "",
            },
            drawdown: {
                drawdown: { label: "Above", value: "Above" },
                conditionValue: "",
            },
            amcNameList: [],
            fundManagerList: [],
            fundNameList: [],
        });
    };
    useEffect(function () {
        if (isAll) {
            var fetchFilterDetails_1 = function (fieldName) { return __awaiter(void 0, void 0, void 0, function () {
                var res, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, aifPmsDi.aifPms.getFilterDetails({
                                    category_code: String(subCategoryId),
                                    fieldName: fieldName,
                                })];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, res];
                        case 2:
                            _a = _b.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            var fetchAllFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
                var amcRes;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchFilterDetails_1(FieldNames.CATEGORY)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, fetchFilterDetails_1(FieldNames.AMCNAME)];
                        case 2:
                            amcRes = _a.sent();
                            if (!amcRes) return [3 /*break*/, 4];
                            return [4 /*yield*/, fetchFilterDetails_1(FieldNames.FUNDMANAGER)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            }); };
            if (Number(subCategoryId) === Number(ESubProductIds.AIF)) {
                fetchAllFilters();
            }
            else {
                fetchFilterDetails_1(FieldNames.AMCNAME).then(function (res) {
                    if (res)
                        fetchFilterDetails_1(FieldNames.FUNDMANAGER);
                });
            }
        }
    }, [subCategoryId]);
    useEffect(function () {
        if (header && subCategoryId) {
            header(aifPmsListData.length, aifPmsLoader);
            setTotalDataRecord &&
                setTotalDataRecord(totalRecord || aifPmsListData.length);
        }
    }, [subCategoryId, aifPmsListData]);
    return (React.createElement("div", { className: "primary-offerings-tabs-wrapper aif-pms-bookmark", id: "primary-offerings-tabs" },
        viewAll == false && (React.createElement(GenericTabs, { loadContentOnlyIfActive: true, defaultActiveKey: tab, activeKey: tab, tabsArray: pmsTabs.map(function (tab) {
                return {
                    title: (device === null || device === void 0 ? void 0 : device.isDesktop) ? tab.title : tab.title,
                    eventKey: tab.eventKey,
                    tabContent: TabContent,
                };
            }), externalClassName: "top-funds-tabs DMSanM_14_500", callBackFunction: function (key) { return setTabValue(key); } })),
        React.createElement("div", { className: "pdl-40 pb-20" }, header && header(totalRecord || aifPmsListData.length, aifPmsLoader)),
        aifPmsListData.length === 0 && (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: noResultsFound, msg: "No Results", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                    React.createElement("p", { className: "DMSanN_14_400" }, "No schemes found for the above selection")) }))),
        error.isOpen ? (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: somethingWentWrong, msg: "Something went wrong", customComp: React.createElement("div", { className: "error-state-button-bar d-flex" },
                    React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing page, or try again later"),
                    React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: function () {
                            setRequestPayload(__assign(__assign({}, requestPayload), { isFocused: tab == "1" ? true : false }));
                        }, hidden: !error.isOpen }, "Try Again")) }))) : (React.createElement(React.Fragment, null,
            React.createElement(TopFundsTableDesk, { pmsSchemeList: aifPmsListData, deleteBookMark: removebookMark, viewAll: true, paramsData: {}, nextPage: onNextPage, page: requestPayload.page, loader: aifPmsLoader, filterDataList: [], setOpenSB: setOpenSB, setRowOpenSb: setRowOpenSb, totalPages: totalPages, dataLengthPerPage: requestPayload.pageSize, setRequestPayload: setRequestPayload, requestPayload: requestPayload, rowOnClick: rowOnClick, onClickPlaceOrder: onClickPlaceOrder, categoryCode: String(subCategoryId), handleApplyFilterCallback: handleApplyFilters, setSummaryData: setSummaryData, summaryData: summaryData, setFilterLabels: setFilterLabels, handleRemoveThroughLabels: handleRemoveThroughLabels, setSelectedValue: setSelectedValue, fundTotalPages: fundTotalPages, setFundTotalPages: setFundTotalPages, isAll: isAll }),
            viewAll && !aifPmsLoader && totalRecord > 5 && (React.createElement("button", { className: "btn d-flex align-items-center txt-han-blue pdl-40 view-all-button mt-2", onClick: function () { return viewAllClick && viewAllClick(viewAllClickPath); } },
                React.createElement("span", { className: "text-decoration-underline DMSanN_16_400" }, "View All"),
                React.createElement("i", { className: "edel-icon-arrow-right-big viewAll-arrow" }))))),
        showToast && (React.createElement(React.Fragment, null,
            React.createElement(GenericToast, { message: React.createElement("div", { className: "d-flex align-items-center gap-2" },
                    toastDetails.isError ? (React.createElement("span", { className: "edel-icon-red-cross rounded-circle" })) : (React.createElement("span", { className: "edel-icon-tick bg-lime-green rounded-circle" })),
                    React.createElement("span", null, toastDetails.msg)), showHeader: false, position: "bottom-center", showCloseButtonInBody: true, theme: "dark-slate-blue", show: showToast, setClose: function () {
                    setShowToast(false);
                }, autohide: true, parentClassName: "product-bouquet-toast" })))));
};
export default TableComponent;
